import type { PlanFreshness } from "../../Types/AccountPlan";
import { formatPlanDate } from "../../Utils/AccountPlans/planDate";

/**
 * A freshness date as "Oct 31". Date-only strings ("2026-10-31") are calendar
 * dates, not instants, so they are not shifted by the viewer's timezone.
 */
export const freshnessDate = (value?: string | null): string =>
  formatPlanDate(value) ?? "—";

/** "Due for a refresh on Oct 31" / "Due for a refresh since Oct 31". */
export const dueLine = (f: PlanFreshness): string =>
  `Due for a refresh ${f.overdue ? "since" : "on"} ${freshnessDate(f.due_at)}`;
